import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { SelectionType } from '@swimlane/ngx-datatable';

import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';

import { Permissions } from '../../common/model/dictionary/Permissions';
import { ChecklistFacade } from '../../common/facade/ChecklistFacade';
import { ApplicationFacade } from '../../common/facade/ApplicationFacade';
import { Strings } from '../../common/language/strings';
import { res } from '../../common/language/text/res';
import { CatalogDetFacade } from '../../common/facade/CatalogDetFacade';
import { LoggerLayout } from '../../common/model/LoggerLayout';
import { LoggerLayoutsFacade } from '../../common/facade/LoggerLayoutsFacade';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  // Properties and Attributes *******************************
  titleActivityScheduler = res.ActivityScheduler;
  lblConsult = res.Consult;
  lblEdit = res.Edit;
  lblProgram = res.Program;
  lblSearch = res.Search;
  lblInvoice = res.Reference;
  lblActivity = res.Activity;
  lblStartDate = res.StartDate;
  lblEndDate = res.EndDate;
  lblBrand = res.Brand;
  lblInstructions = res.Instructions;
  lblPeriodicity = res.Periodicity;
  lblStatus = res.Status;
  lblSelectStatus = res.SelectStatus;
  lblSelectAnOption = res.SelectAnOption;
  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };
  isSpanish = true;

  private _urlBase: string;

  // permissions
  permissionsList: any[] = [];

  // table
  @ViewChild('tableChecklist') tableChecklist: DatatableComponent;
  rows: any[] = [];
  _filteredData = [];
  selected: any[] = [];
  SelectionType = SelectionType;

  loading = false;
  messageLoader = '';
  currentDate = Date;

  // actions
  add = 1;
  see = 2;
  edit = 3;

  // buttons
  visibleAdd = false;
  visibleSee = false;
  visibleEdit = false;

  // alert
  alerts: any[] = [];

  // icon
  faClipboardCheck = faClipboardCheck;
  language: number = 0;
  lstStatus: any;
  catDetTypeId = -1;

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    @Inject('BASE_URL') baseUrl: string,
    private _router: Router,
    private _facadeChecklist: ChecklistFacade,
    private _facadeApplication: ApplicationFacade,
    private _facadeCatDet: CatalogDetFacade,
    private _facadeLog: LoggerLayoutsFacade,
    public strings: Strings,
    private _route: ActivatedRoute
  ) {
    this._storage.set('moduleUrl', this._router.url);
    this._urlBase = baseUrl;
  }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingChecklistList);

    // validar permisos
    this.validatePermissions();

    this._facadeApplication.GetCurrentDate().subscribe(result => {
      this.currentDate = result;
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      return;
    });

    this.language = 0;
    if (!this.isSpanish) {
      this.language = 1;
    }
    this._facadeChecklist.GetChecklist(this.language).subscribe(result => {
      if (result.completed) {
        this.rows = result.data;
        this._filteredData = result.data;
        this.getStatus();

        this._route.queryParams.subscribe(params => {
          if (params['status'] !== undefined) {
            this.catDetTypeId = params['status'] === 'Inactivo' ? 45 : 44;
          }
          else {
            this.catDetTypeId = 44;
          }
        });
      }

      this.loading = false;
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + error + '</strong>', 'danger');

      var log = new LoggerLayout();
      var userInfo = this._storage.get('user');

      log.message = error;
      log.layoutIncidence = 'checklist';
      log.userName = userInfo.account;
      log.incidenceType = 1;

      this._facadeLog.AddNewIncident(log).subscribe(result => {
        if (result.completed) {
          console.log('Ha ocurrido un error, contacta al administrador del sistema.')
        }
      });

      return;
    });


  }

  validatePermissions() {
    this.permissionsList = this._storage.get('permissions');

    // validar si cuenta con el permiso para añadir un nuevo checklist
    this.permissionsList.forEach(element => {
      if (element.name === Permissions.AdminChecklistGenericCreate
        || element.name === Permissions.AdminChecklistLevelChangeCreate
        || element.name === Permissions.AdminChecklistOpenCloseCreate
        || element.name === Permissions.GeneralAccess) {
        this.visibleAdd = true;
      }
    });

    // validar si cuenta con el permiso para consultar un checklist
    this.permissionsList.forEach(element => {
      if (element.name === Permissions.AdminChecklistGenericRead
        || element.name === Permissions.AdminChecklistLevelChangeRead
        || element.name === Permissions.AdminChecklistOpenCloseRead
        || element.name === Permissions.GeneralAccess) {
        this.visibleSee = true;
      }
    });

    // validar si cuenta con el permiso para editar un checklist
    this.permissionsList.forEach(element => {
      if (element.name === Permissions.AdminChecklistGenericEdit
        || element.name === Permissions.AdminChecklistLevelChangeEdit
        || element.name === Permissions.AdminChecklistOpenCloseEdit
        || element.name === Permissions.GeneralAccess) {
        this.visibleEdit = true;
      }
    });
  }

  // añadir alert
  addAlert(message: String, type: String): void {
    this.alerts.push({
      type: type,
      msg: message,
      timeout: 8000
    });
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the amount of columns in the table

    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);

    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {

        if (item[keys[i]] != null &&
          (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
          return true;
        }
      }
    });

    this.tableChecklist.offset = 0;
  }

  validateRow(): Boolean {
    if (this.selected.length === 0) {
      this.addAlert(this.strings.GetText(res.AlertSelectRecordPerformSelectedAction), 'warning');

      var log = new LoggerLayout();
      var userInfo = this._storage.get('user');

      log.message = this.strings.GetText(res.AlertSelectRecordPerformSelectedAction);
      log.layoutIncidence = 'checklist';
      log.userName = userInfo.account;
      log.incidenceType = 2;

      this._facadeLog.AddNewIncident(log).subscribe(result => {
        if (result.completed) {
          console.log('Ha ocurrido un error, contacta al administrador del sistema.')
        }
      });

      return false;
    } else {
      return true;
    }
  }

  newChecklist() {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        'action': this.add,
        'taskId': 0,
        'checklistId': 0
      }
    };

    this._router.navigate(['admin/checklist'], navigationExtras).then((e) => {
      if (e) {
        console.log('Navigation is successful!');
      } else {
        console.log('Navigation has failed!');
      }
    });
  }

  seeChecklist() {
    if (this.validateRow()) {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          'action': this.see,
          'taskId': this.selected[0].taskId,
          'checklistId': this.selected[0].checklistId,
          'status': this.selected[0].status
        }
      };

      this._router.navigate(['admin/checklist'], navigationExtras).then((e) => {
        if (e) {
          console.log('Navigation is successful!');
        } else {
          console.log('Navigation has failed!');
        }
      });
    }
  }

  seeChecklistRow(taskId: number, checklistId: number, chksStatus: number) {
    if (this.visibleSee) {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          'action': this.see,
          'taskId': taskId,
          'checklistId': checklistId,
          'status': chksStatus
        }
      };

      this._router.navigate(['admin/checklist'], navigationExtras).then((e) => {
        if (e) {
          console.log('Navigation is successful!');
        } else {
          console.log('Navigation has failed!');
        }
      });
    }
  }

  editChecklist() {
    if (this.validateRow()) {
      /*
      if (this.currentDate >= this.selected[0].startDate)
      {
        this.addAlert('No se puede editar el checklist seleccionado, ya a iniciado su vigencia','danger')
        return
      }
      if (this.selected[0].notificationSent > 0)
      {
        this.addAlert('No se puede editar el checklist seleccionado, ya se han enviado notificaciones','danger')
        return
      }
      */
      const navigationExtras: NavigationExtras = {
        queryParams: {
          'action': this.edit,
          'taskId': this.selected[0].taskId,
          'checklistId': this.selected[0].checklistId,
          'status': this.selected[0].status
        }
      };

      this._router.navigate(['admin/checklist'], navigationExtras).then((e) => {
        if (e) {
          console.log('Navigation is successful!');
        } else {
          console.log('Navigation has failed!');
        }
      });
    }
  }

  getStatus() {
    // get TaskType
    this._facadeCatDet.Get(30, this.language).subscribe(result => {
      if (result.completed) {
        if (result.data !== null) {
          this.lstStatus = result.data;
          this.onStatusChange();
        }
      }
    }, error => {
      this.loading = false;
      this.addAlert('<strong>' + error + '</strong>', 'danger');

      var log = new LoggerLayout();
      var userInfo = this._storage.get('user');

      log.message = error;
      log.layoutIncidence = 'checklist';
      log.userName = userInfo.account;
      log.incidenceType = 1;

      this._facadeLog.AddNewIncident(log).subscribe(result => {
        if (result.completed) {
          console.log('Ha ocurrido un error, contacta al administrador del sistema.')
        }
      });

      return;
    });
  }

  onStatusChange() {
    if (this.catDetTypeId == -1) {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.status.toString() === this.lstStatus.find(x => x.catDetId == this.catDetTypeId).name.toString());
      });
    }
  }
}